import React from "react";
import RemoveIcon from "@mui/icons-material/Remove";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import DividerView from "./DividerView";
import {clampDividerThickness, parseDividerLabel} from "./printoutDividerOptions";

const PrintoutDividerNodeView = (props: NodeViewProps) => {
    const color = typeof props.node.attrs.color === "string" ? props.node.attrs.color : null;
    const label = parseDividerLabel(props.node.attrs.label);
    const role = props.node.attrs.role === "footer" ? "footer" : undefined;
    const thickness = clampDividerThickness(props.node.attrs.thickness);

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutDivider"
            dataAttributes={role ? {"data-printout-divider-role": role} : undefined}
            icon={<RemoveIcon fontSize="small"/>}
            label="Divider"
        >
            <DividerView attrs={{color, label, thickness}}/>
        </PrintoutBlockShell>
    );
};

export default PrintoutDividerNodeView;
